import { TextInput, TextInputNorlys } from '../BaseInput';
import { EmailInputProps } from './types';
import { useHandleEmailInputChange } from './util';

export const EmailInput = ({ label, value, onChange, ...rest }: EmailInputProps) => {
  const { email, valid, handleChangeEvent } = useHandleEmailInputChange(value, onChange);

  return (
    <TextInput
      {...{
        placeholder: 'email@email.com',
        label: label ?? 'Email',
        status: !valid && !!email?.length ? 'error' : undefined,
        value: email,
        onChange: newValue => {
          handleChangeEvent(newValue.replace(/([^a-z-\d_. æøåÆØÅ@]+)/gi, ''));
        },
        ...rest,
      }}
    />
  );
};

export const EmailInputNorlys = ({ label, value, onChange, ...rest }: EmailInputProps) => {
  const { email, valid, handleChangeEvent } = useHandleEmailInputChange(value, onChange);

  return (
    <TextInputNorlys
      {...{
        placeholder: 'email@email.com',
        label: label ?? 'Email',
        status: !valid && !!email?.length ? 'error' : undefined,
        value: email,
        onChange: newValue => {
          handleChangeEvent(newValue.replace(/([^a-z-\d_. æøåÆØÅ@]+)/gi, ''));
        },
        ...rest,
      }}
    />
  );
};
